import React from 'react';
import { motion, AnimatePresence } from 'motion/react';
import { X, Download, ZoomIn, ZoomOut } from 'lucide-react';

interface ImageModalProps {
  url: string | null;
  name: string;
  isOpen: boolean;
  onClose: () => void;
}

export const ImageModal: React.FC<ImageModalProps> = ({ url, name, isOpen, onClose }) => {
  if (!url) return null;

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-[500] flex items-center justify-center p-4 md:p-12">
          <motion.div 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="absolute inset-0 bg-slate-950/90 backdrop-blur-xl"
          />
          
          <motion.div 
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            className="relative max-w-5xl w-full h-full flex flex-col items-center justify-center pointer-events-none"
          >
            <div className="absolute top-0 right-0 p-4 flex gap-4 pointer-events-auto">
              <a 
                href={url} 
                download 
                className="p-3 bg-white/10 hover:bg-white/20 text-white rounded-2xl backdrop-blur-md transition-all"
                title="Download Image"
              >
                <Download size={24} />
              </a>
              <button 
                onClick={onClose}
                className="p-3 bg-white/10 hover:bg-white/20 text-white rounded-2xl backdrop-blur-md transition-all"
              >
                <X size={24} />
              </button>
            </div>

            <div className="relative group pointer-events-auto cursor-zoom-in">
               <img 
                src={url} 
                alt={name || "Enlarged view"} 
                className="max-w-full max-h-[80vh] object-contain rounded-2xl shadow-2xl"
                referrerPolicy="no-referrer"
              />
            </div>
            
            <div className="mt-8 text-center pointer-events-auto">
              <p className="text-white font-black uppercase tracking-[0.3em] mb-1">{name}</p>
              <p className="text-white/40 text-[10px] font-black uppercase tracking-[0.3em]">Precision Visual Diagnostics</p>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};